import React from "react";

import iconContext from "./iconContext.jsx";

export default function IconProvider({
  children,
  icons,
  getIconSrc,
  ...restProps
}) {
  if (!getIconSrc && icons) {
    getIconSrc = (name) => icons[name];
  }
  return (
    <iconContext.Provider
      value={{
        icons,
        getIconSrc,
        ...restProps,
      }}
    >
      {children}
    </iconContext.Provider>
  );
}
